import styled from 'styled-components';

import { ICON_CLOSE } from 'assets/icons';

import Text from 'components/common/Text';
import CommonImage from 'components/common/CommonImage';

import ModalContainer from 'containers/ProductRegist/components/common/ModalContainer';
import { HostDashBoard } from 'containers/Menu/graphQL/types';

const ModalHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  height: 76px;
  padding: 24px 20px;
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;

  padding: 0px 20px 48px;
`;

const DataBox = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;

  margin-bottom: 16px;
`;

const DataCategory = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.4%;

  color: rgba(27, 28, 30, 1);
`;

const DataValue = styled.span`
  font-weight: 400;
  font-size: 20px;
  line-height: 26px;
  letter-spacing: -0.6px;
  text-align: right;

  color: rgba(112, 115, 124, 1);
`;

interface Props {
  handleOverviewModal: () => void;
  isMobile: boolean;
  hostDashboard: HostDashBoard;
}

function OverviewDataModal({
  handleOverviewModal,
  isMobile,
  hostDashboard,
}: Props) {
  const overviewData = hostDashboard.hostDashboard.hostDashboard;

  return (
    <ModalContainer
      isMobile={isMobile}
      isAbled={true}
      onClick={() => {}}
      onClose={() => {}}
      isBottomSheet
      style={{ gap: 0 }}
    >
      <ModalHeader>
        <Text
          weight={600}
          size="20px"
          style={{ lineHeight: '28px' }}
          color="rgba(27, 28, 30, 1)"
        >
          판매 데이터
        </Text>

        <CommonImage src={ICON_CLOSE} onClick={handleOverviewModal} />
      </ModalHeader>

      <ModalBody>
        <Text
          size="13px"
          color="rgba(27, 28, 30, 1)"
          weight={500}
          style={{ marginBottom: '6px' }}
        >
          이번 달 판매금액
        </Text>
        <Text
          size="24px"
          color="rgba(27, 28, 30, 1)"
          style={{ lineHeight: '30px', marginBottom: '24px' }}
          weight={600}
        >
          {overviewData.monthlyTurnover
            ? Number(overviewData.monthlyTurnover).toLocaleString()
            : 0}
          원
        </Text>

        <DataBox>
          <DataCategory>이번 달 판매 건수</DataCategory>
          <DataValue>
            {overviewData.monthlySaleCount
              ? overviewData.monthlySaleCount.toLocaleString()
              : 0}
            건
          </DataValue>
        </DataBox>

        <DataBox>
          <DataCategory>이번달 취소 수</DataCategory>
          <DataValue>
            {overviewData.monthlyCancel
              ? overviewData.monthlyCancel.toLocaleString()
              : 0}
            건
          </DataValue>
        </DataBox>

        <DataBox>
          <DataCategory>누적 판매금액</DataCategory>
          <DataValue>
            {overviewData.totalTurnover
              ? overviewData.totalTurnover.toLocaleString()
              : 0}
            원
          </DataValue>
        </DataBox>

        <DataBox>
          <DataCategory>누적 판매 수</DataCategory>
          <DataValue>
            {overviewData.totalSaleCount
              ? overviewData.totalSaleCount.toLocaleString()
              : 0}
            건
          </DataValue>
        </DataBox>
      </ModalBody>
    </ModalContainer>
  );
}

export default OverviewDataModal;
